(function () {
  'use strict';

  var overlay  = document.getElementById('syoat-search');
  var backdrop = document.getElementById('syoat-search-backdrop');
  if (!overlay) return;

  var input       = document.getElementById('syoat-search-input');
  var closeBtn    = document.getElementById('syoat-search-close');
  var submitBtn   = overlay.querySelector('.syoat-search__submit');
  var resultsBody = document.getElementById('syoat-results-body');
  var timer;
  var requestId = 0;
  var controller;
  var isOpen = false;
  var returnFocus;
  var previousOverflow = '';
  var closeTimer;
  var focusTimer;
  var inertElements = [];

  // Syoat: Invalidate responses immediately, including while a new query debounces.
  function cancelSearch() {
    clearTimeout(timer);
    requestId++;
    if (controller) controller.abort();
    controller = null;
    resultsBody.setAttribute('aria-busy', 'false');
  }

  function isolateDialog() {
    var branch = overlay;
    while (branch.parentElement && branch !== document.body) {
      Array.from(branch.parentElement.children).forEach(function (sibling) {
        if (sibling !== branch && sibling !== backdrop && !sibling.inert) {
          inertElements.push(sibling);
          sibling.inert = true;
        }
      });
      branch = branch.parentElement;
    }
  }

  /* Syoat: Build storefront URLs from Shopify's locale-aware root. */
  function getShopifyRoute(path) {
    var root = window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root + path.replace(/^\/+/, '');
  }

  // Syoat: Keep focus in the search dialog and restore it when closing.
  function open(trigger) {
    if (isOpen) return;
    clearTimeout(closeTimer);
    clearTimeout(focusTimer);
    isOpen = true;
    returnFocus = trigger || document.activeElement;
    previousOverflow = document.body.style.overflow;
    overlay.classList.remove('is-closing');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.style.display = 'flex';
    isolateDialog();
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      if (!isOpen) return;
      overlay.classList.add('is-open');
      backdrop.classList.add('is-open');
      input.focus();
      focusTimer = setTimeout(function () { if (isOpen) input.focus(); }, 200);
    });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    cancelSearch();
    clearTimeout(focusTimer);
    overlay.classList.remove('is-open');
    overlay.classList.add('is-closing');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = previousOverflow;
    inertElements.forEach(function (element) { element.inert = false; });
    inertElements = [];
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    overlay.setAttribute('aria-hidden', 'true');
    input.value = '';
    resultsBody.innerHTML = '';
    closeTimer = setTimeout(function () {
      if (isOpen) return;
      overlay.classList.remove('is-closing');
      overlay.style.display = 'none';
    }, 320);
  }

  /* ── Search ── */
  function doSearch(query) {
    query = query.trim();
    if (!query) { resultsBody.innerHTML = ''; return; }

    var activeRequest = requestId;
    controller = new AbortController();
    resultsBody.setAttribute('aria-busy', 'true');
    resultsBody.innerHTML = '<p class="syoat-searching">Searching...</p>';

    fetch(getShopifyRoute('search/suggest.json') + '?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=8', { signal: controller.signal })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Predictive search request failed: ' + response.status);
        }

        return response.json();
      })
      .then(function (data) {
        if (!isOpen || activeRequest !== requestId) return;
        resultsBody.setAttribute('aria-busy', 'false');
        var products = (data.resources &&
          data.resources.results &&
          data.resources.results.products) || [];

        if (!products.length) {
          resultsBody.innerHTML =
            '<p class="syoat-no-results">No results for &ldquo;' + esc(query) + '&rdquo;</p>';
          return;
        }

        var html = '<div class="syoat-grid">';
        products.forEach(function (p) {
          html +=
            '<a href="' + esc(p.url || getShopifyRoute('products/' + p.handle)) + '" class="syoat-card">' +
              '<div class="syoat-card__img">' +
                (p.image
                  ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">'
                  : '<div class="syoat-card__no-img"></div>') +
              '</div>' +
              '<div class="syoat-card__info">' +
                '<p class="syoat-card__title">' + esc(p.title) + '</p>' +
                (p.price ? '<p class="syoat-card__price">' + esc(p.price) + '</p>' : '') +
              '</div>' +
            '</a>';
        });
        html += '</div>';
        resultsBody.innerHTML = html;
      })
      .catch(function (error) {
        if (!isOpen || activeRequest !== requestId || error.name === 'AbortError') return;
        resultsBody.setAttribute('aria-busy', 'false');
        resultsBody.innerHTML = '<p class="syoat-no-results">Something went wrong. Try again.</p>';
      });
  }

  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ── Intercept search icon on mobile ── */
  document.querySelectorAll('[data-search-trigger], .icon-only-search-trigger')
    .forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (window.innerWidth <= 960) {
          e.preventDefault();
          e.stopImmediatePropagation();
          open(el);
        }
      }, true);
    });

  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);

  input.addEventListener('input', function () {
    cancelSearch();
    var q = this.value.trim();
    if (!q) { resultsBody.innerHTML = ''; return; }
    timer = setTimeout(function () { doSearch(q); }, 300);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = this.value.trim();
      if (q) window.location.href = getShopifyRoute('search') + '?q=' + encodeURIComponent(q);
    }
  });

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var q = input.value.trim();
      if (q) window.location.href = getShopifyRoute('search') + '?q=' + encodeURIComponent(q);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.from(overlay.querySelectorAll('button, input, a[href], [tabindex="0"]'))
      .filter(function (el) { return !el.disabled && el.getClientRects().length; });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!first) { e.preventDefault(); overlay.focus(); return; }
    if (e.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) {
      e.preventDefault(); first.focus();
    }
  });

  document.addEventListener('focusin', function (event) {
    if (isOpen && !overlay.contains(event.target)) input.focus();
  });

})();

/* ---- Syoat Gallery Arrows + Dots v4 ---- */
(function() {
  function init() {
    const gallery = document.querySelector('.product__media-container.below-mobile .product__media');
    if (!gallery) return;

    const track = gallery.querySelector('.scroll-slider__slider');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.product__media-item:not([data-syoat-gallery-clone])'));
    if (slides.length <= 1) return;
    if (gallery.querySelector('.syoat-arrow')) return;

    const startClone = track.querySelector('[data-syoat-gallery-clone="start"]');
    const endClone = track.querySelector('[data-syoat-gallery-clone="end"]');
    const trackSlides = Array.from(track.querySelectorAll('.product__media-item'));
    const productRoot = gallery.closest('[data-section-type="product"]');

    // The boundary clone adds one item before the real slides. Keep the hidden
    // mobile thumbnail indexes aligned with the native scroll-slider positions.
    if (startClone && productRoot) {
      productRoot.querySelectorAll('[data-thumbnail-size="mobile"] [data-product-thumbnail]').forEach((thumb, index) => {
        thumb.dataset.thumbnailIndex = index + 1;
      });
    }

    let currentIndex = 0;
    let scrollEndTimer;
    let normalizingBoundary = false;
    const scrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    // --- Dots ---
    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'syoat-dots';
    const dots = slides.map((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'syoat-dot';
      dot.setAttribute('aria-label', 'Show product media ' + (i + 1));
      dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: scrollBehavior(), inline: 'center', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
      return dot;
    });
    gallery.parentNode.insertBefore(dotsWrap, gallery.nextSibling);

    // --- Arrows ---
    const createArrow = (side) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'syoat-arrow syoat-arrow--' + side;
      btn.setAttribute('aria-label', side === 'left' ? 'Previous media' : 'Next media');
      const points = side === 'left' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + points + '"></polyline></svg>';
      return btn;
    };

    const leftBtn = createArrow('left');
    const rightBtn = createArrow('right');
    gallery.appendChild(leftBtn);
    gallery.appendChild(rightBtn);

    const setActive = (index) => {
      if (index < 0 || index >= slides.length) return;
      currentIndex = index;
      dots.forEach((d, i) => {
        d.classList.toggle('active', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      leftBtn.removeAttribute('aria-disabled');
      rightBtn.removeAttribute('aria-disabled');
      leftBtn.style.opacity = '1';
      leftBtn.style.pointerEvents = 'auto';
      rightBtn.style.opacity = '1';
      rightBtn.style.pointerEvents = 'auto';
    };

    setActive(0);

    const goToSlide = (slide, behavior = scrollBehavior()) => {
      if (!slide) return;
      slide.scrollIntoView({ behavior, inline: 'center', block: 'nearest' });
    };

    const jumpToRealSlide = (slide) => {
      if (!slide) return;
      const previousScrollBehavior = track.style.scrollBehavior;
      const previousScrollSnapType = track.style.scrollSnapType;

      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = slide.offsetLeft;

      // Force the non-animated position to commit before restoring scroll snap.
      track.getBoundingClientRect();
      requestAnimationFrame(() => {
        track.style.scrollBehavior = previousScrollBehavior;
        track.style.scrollSnapType = previousScrollSnapType;
      });
    };

    leftBtn.addEventListener('click', () => {
      const targetIndex = (currentIndex - 1 + slides.length) % slides.length;
      goToSlide(currentIndex === 0 && startClone ? startClone : slides[targetIndex]);
      setActive(targetIndex);
    });
    rightBtn.addEventListener('click', () => {
      const targetIndex = (currentIndex + 1) % slides.length;
      goToSlide(currentIndex === slides.length - 1 && endClone ? endClone : slides[targetIndex]);
      setActive(targetIndex);
    });

    // --- Detect active slide by which one is closest to gallery center ---
    const closestTrackSlide = () => {
      const trackRect = track.getBoundingClientRect();
      const centerX = trackRect.left + trackRect.width / 2;
      let closestSlide = trackSlides[0];
      let closestDistance = Infinity;
      trackSlides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - centerX);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
        }
      });
      return closestSlide;
    };

    const detectActive = () => {
      const closestSlide = closestTrackSlide();
      if (!closestSlide) return;

      if (closestSlide.hasAttribute('data-syoat-gallery-clone')) {
        setActive(Number(closestSlide.dataset.cloneRealIndex));
        return;
      }

      const closestIndex = slides.indexOf(closestSlide);
      if (closestIndex >= 0) setActive(closestIndex);
    };

    // Once a boundary clone finishes sliding into view, jump silently to its
    // matching real slide. The customer sees continuous directional movement.
    const normalizeBoundary = () => {
      if (normalizingBoundary) return;
      const closestSlide = closestTrackSlide();
      if (!closestSlide || !closestSlide.hasAttribute('data-syoat-gallery-clone')) return;

      const realIndex = Number(closestSlide.dataset.cloneRealIndex);
      const realSlide = slides[realIndex];
      if (!realSlide) return;

      normalizingBoundary = true;
      jumpToRealSlide(realSlide);
      setActive(realIndex);
      requestAnimationFrame(() => { normalizingBoundary = false; });
    };

    const handleTrackScroll = () => {
      requestAnimationFrame(detectActive);
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(normalizeBoundary, 300);
    };

    track.addEventListener('scroll', handleTrackScroll, { passive: true });
    track.addEventListener('scrollend', normalizeBoundary, { passive: true });

    // Touch swipes can also enter a boundary clone, so normalize after momentum settles.
    track.addEventListener('touchend', () => {
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(normalizeBoundary, 300);
    }, { passive: true });

    // Initial check after layout settles
    setTimeout(detectActive, 100);
    setTimeout(detectActive, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- Syoat Sticky ATC — Strip + Qty ---- */
(function() {
  const msgs = [
    '🚚 Free Shipping',
    '💳 100% Secure Transaction'
  ];
  let msgIdx = 0;
  let qty = 1;

  function initStickyBar() {
    const bar = document.querySelector('.sticky-atc-bar');
    const btnWrap = document.querySelector('.sticky-atc-bar__button');
    const inner = document.querySelector('.sticky-atc-bar__inner');
    if (!bar || !btnWrap || !inner) return;

    /* --- Offer Strip --- */
    if (!bar.querySelector('.syoat-strip')) {
      const strip = document.createElement('div');
      strip.className = 'syoat-strip';
      strip.textContent = msgs[0];
      bar.insertBefore(strip, bar.firstChild);

      setInterval(function() {
        strip.style.opacity = '0';
        setTimeout(function() {
          msgIdx = (msgIdx + 1) % msgs.length;
          strip.textContent = msgs[msgIdx];
          strip.style.opacity = '1';
        }, 400);
      }, 3000);
    }

    /* --- Qty Selector --- */
    if (!btnWrap.querySelector('.syoat-qty')) {
      if (!inner.querySelector('.syoat-qty-hidden')) {
        const inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'quantity';
        inp.value = '1';
        inp.className = 'syoat-qty-hidden';
        inner.appendChild(inp);
      }
      const hiddenQty = inner.querySelector('.syoat-qty-hidden');

      const wrap = document.createElement('div');
      wrap.className = 'syoat-qty';
      wrap.innerHTML = '<button type="button" class="syoat-qty__btn" data-act="dec">−</button>'
        + '<span class="syoat-qty__num">1</span>'
        + '<button type="button" class="syoat-qty__btn" data-act="inc">+</button>';
      btnWrap.insertBefore(wrap, btnWrap.firstChild);

      const numEl = wrap.querySelector('.syoat-qty__num');

      wrap.querySelector('[data-act="dec"]').addEventListener('click', function() {
        if (qty > 1) { qty--; numEl.textContent = qty; hiddenQty.value = qty; }
      });
      wrap.querySelector('[data-act="inc"]').addEventListener('click', function() {
        qty++; numEl.textContent = qty; hiddenQty.value = qty;
      });
    }
  }

  setTimeout(initStickyBar, 800);
  setTimeout(initStickyBar, 1500);
  window.addEventListener('scroll', function() {
    setTimeout(initStickyBar, 300);
  }, { once: true });
})();
